import { CustomTheme } from '@ibe/components';
import { reactSelectStyles } from './reactSelectStyles';
import styles from './Styles/Bootstrap.scss';

export const customTheme: CustomTheme = {
  bootstrap: styles,
  searchCriteriaDisplay: {
    color: styles.secondary,
    backgroundColor: styles.white
  },
  useCalenderIcon: false,
  reactSelectStyles,
  paxSelectionOptions: {
    withIcon: false,
    shortTitle: false,
    longTitle: true
  },
  dateRangePickerOptions: {
    defaultDaysAddedToStart: 14,
    defaultDaysAddedToEnd: 28
  }
};
